module.exports = __webpack_public_path__ + "static/media/rayul.4107dbc3.png";